import { render, staticRenderFns } from "./repsTable.vue?vue&type=template&id=6cbe1a10&"
import script from "./repsTable.vue?vue&type=script&lang=js&"
export * from "./repsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports